import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
 
@Injectable({
    providedIn: 'root'   
})
export class UpdateUsernameService {
 
  // Observable string sources
  private profileUpdatedAnnouncedSource = new Subject<string>();
  private profileUpdatedConfirmedSource = new Subject<string>();
 
  // Observable string streams
  profileUpdatedAnnounced$ = this.profileUpdatedAnnouncedSource.asObservable();
  profileUpdatedConfirmed$ = this.profileUpdatedConfirmedSource.asObservable();
 
 
  confirmProfileUpdated(username: string) {
    this.profileUpdatedConfirmedSource.next(username);
  }
}